import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";

const useQuery = () => new URLSearchParams(useLocation().search);

export const useUrlParamSync = ({
  paramName,
  defaultVal = "",
}: {
  paramName: string;
  defaultVal: string;
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const query = useQuery();
  const [state, setState] = useState(query.get(paramName) || defaultVal);

  useEffect(() => {
    const currentQuery = new URLSearchParams(location.search);
    const queryState = currentQuery.get(paramName);

    if (queryState !== state) {
      currentQuery.set(paramName, state);
      navigate(`${location.pathname}?${currentQuery.toString()}`, {
        replace: true,
      });
    }
  }, [state, location, navigate, paramName]);

  return [state, setState] as const;
};
